import * as React from "react";
import { baseTheme } from "../styles/baseTheme";

export const LAYOUT_MOBILE_HEADER_HEIGHT = 56;

/** Drawer/backdrop open-close transition (ms). */
export const LAYOUT_MOBILE_MENU_TRANSITION_MS = 280;

export function useIsLayoutMobile(): boolean {
  const [isMobile, setIsMobile] = React.useState(false);

  React.useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${baseTheme.breakpoints.layoutMobile})`);
    setIsMobile(mq.matches);
    const handler = () => setIsMobile(mq.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

  return isMobile;
}
